const PRODUCT_ENTITY_TYPES = ["product", "product-family", "product-skus"];

// Menu defines these as the Products group. Linked-to tables apply that group here so the block
// stays in front of RIMS even when the loaded menu still has the previous grouping.
export function splitProductsFromRims(entityTypes) {
    if (!entityTypes || entityTypes.length === 0)
        return entityTypes || [];

    const products = [];
    const rest = [];

    entityTypes.forEach((item) => {
        if (PRODUCT_ENTITY_TYPES.includes(item.EntityType) || item.EntityGroup === "Products")
            products.push({ ...item, EntityGroup: "Products" });
        else
            rest.push(item);
    });

    if (products.length === 0)
        return entityTypes;

    const rimsIndex = rest.findIndex((item) => item.EntityGroup === "RIMS");
    if (rimsIndex === -1)
        return [...products, ...rest];

    return [
        ...rest.slice(0, rimsIndex),
        ...products,
        ...rest.slice(rimsIndex),
    ];
}
